/**
 * Service worker kaydi.
 *
 * ## Yalnizca URETIMDE
 *
 * Vite dev sunucusunda service worker, HMR ile catisiyor: modul istekleri
 * onbellekten servis edilince degisiklikler gorunmuyor ve sebebi bulunamiyor
 * ("kaydettim ama degismiyor"). `import.meta.env.PROD` kontrolu bunu kesin
 * olarak kapatiyor.
 *
 * ## Kapsam `/app/`
 *
 * Service worker yalnizca SPA'yi yonetiyor; `/` (eski arayuz) ve `/api`
 * kapsamin DISINDA. `scope` acikca veriliyor cunku varsayilan kapsam
 * script'in bulundugu dizin ve bir gun `sw.js` tasinirsa kapsam sessizce
 * degisir.
 *
 * ## HTTPS gerekiyor (localhost haric)
 *
 * Tarayicilar service worker'i yalnizca guvenli baglamda kaydediyor. LAN'da
 * duz HTTP ile kayit SESSIZCE basarisiz oluyor - o yuzden hatayi yutmuyoruz,
 * ama uygulamayi da durdurmuyoruz: PWA bir kolaylik, calisma sarti degil.
 */

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return
  if (!('serviceWorker' in navigator)) return

  // `load` olayini bekliyoruz: kayit, ilk render ile ag icin yarismamali.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Guvenli olmayan baglam veya kullanici tarafindan devre disi
      // birakilmis. Uygulama calismaya devam ediyor; yalnizca cevrimdisi
      // kabuk ve (ileride) push yok.
    })
  })
}
